import { http } from '../config';
import base from './base';

export const timetable = {
  commentNormalClass(data) {
    //提交普通课评价
    return http({
      url: `${base.datebook}/teacherClass/commentsForStu`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  getTimetableList(data) {
    //获取课程表列表
    return http({
      url: `${base.datebook}/teacherClass/bookedClass`,
      method: 'post',
      data
    });
  },
  commentAssessClass(data) {
    //提交测评课评价
    return http({
      url: `${base.datebook}/teacherClass/assessCommentSub`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  getNormalComment(id) {
    //获取普通课评论内容
    return http({
      url: `${base.datebook}/teacherClass/noAssessClass/${id}`,
      method: 'get'
    });
  },
  getAssessComment(id) {
    //获取测评课评论内容
    return http({
      url: `${base.datebook}/teacherClass/assessClass/${id}`,
      method: 'get'
    });
  },
  viewFeedback(datebookId) {
    //查看学生反馈
    return http({
      url: `${base.datebook}/teacherClass/viewFeedback/${datebookId}`,
      method: 'get'
    });
  },
  previewClassFile(datebookId, lrId) {
    //教材预览
    return http({
      url: `${base.datebook}/teacherClass/previewClassFile/${datebookId}/${lrId}`,
      method: 'get',
      hideMessage: true
    });
  },
  previewStuClassFile(datebookId) {
    //老师下载学生发送的资料
    return http({
      url: `${base.async}/teacherFile/downloadStudentResource/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  previewStudentFile(datebookId) {
    //预览学生文件
    return http({
      url: `${base.datebook}/teacherClass/previewStudentFile/${datebookId}`,
      method: 'get'
    });
  },
  toCommentsForStu(datebookId) {
    //去评价学生判断
    return http({
      url: `${base.datebook}/teacherClass/toCommentsForStu/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  ocClassComment(data) {
    //机构课评价提交
    return http({
      url: `${base.datebook}/teacherClass/ocClassComment`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  joinClassRoom(datebookId) {
    //老师打卡
    return http({
      url: `${base.datebook}/teacherClass/joinClassRoom/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  joinClass(datebookId) {
    //进入教室
    return http({
      url: `${base.datebook}/teacherClass/joinClass/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  sendVoiceMsgToStu(datebookId) {
    //发语音提示给学生
    return http({
      url: `${base.datebook}/teacherClass/sendVoiceMsgToStu/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  viewStudentComment(data) {
    //查看学生的所有评价
    return http({
      url: `${base.datebook}/teacherClass/studentComment`,
      method: 'post',
      data
    });
  },
  cancelClass(data) {
    //取消课程
    return http({
      url: `${base.datebook}/teacherClass/cancelClass`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  checkCancelClass(datebookId) {
    //取消课程前检查
    return http({
      url: `${base.datebook}/teacherClass/checkCancelClass/${datebookId}`,
      method: 'get',
      hideMessage: true
    });
  },
  queryBindLessonInfo(data) {
    //获取上一节或者下一节课文信息
    return http({
      url: `${base.datebook}/teacherClass/queryBindLessonInfo`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  bindClassRoomFile(data) {
    //绑定课件
    return http({
      url: `${base.datebook}/teacherClass/bindClassRoomFile`,
      method: 'post',
      data,
      hideMessage: true
    });
  },
  querySubmitLearnDemand(datebookId) {
    return http({
      url: `${base.datebook}/teacherClass/querySubmitLearnDemand/${datebookId}`,
      method: 'get'
    });
  },
  uploadFile(data) {
    //上传文件到腾讯云
    return http({
      url: `${base.async}/fileServer/uploadFile`,
      method: 'post',
      data
    });
  },
  downloadFile(data) {
    //腾讯云文件下载
    return http({
      url: `${base.async}/fileServer/downloadFile`,
      method: 'post',
      data
    });
  },
  queryTeaAiReport(datebookId) {
    //查询AI报告
    return http({
      url: `${base.datebook}/teacherClass/queryTeaAiReport/${datebookId}`,
      method: 'get'
    });
  },
  updateStuAiReport(data) {
    return http({
      url: `${base.datebook}/teacherClass/updateStuAiReport`,
      method: 'post',
      data
    });
  },
  queryUserEvaluateQuestionnaire(data) {
    // 需求2.5.1：查看用户首次测评课问卷调查结果（老师端）
    return http({
      url: `${base.datebook}/teacherClass/queryUserEvaluateQuestionnaire`,
      method: 'post',
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/timetable.js